import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Returns an axios instance with the current admin bearer token. */
export const authApi = (token) => axios.create({
  baseURL: API,
  headers: { Authorization: `Bearer ${token}` },
});

/** Format INR with lakh/crore suffix. */
export const inr = (n) => {
  if (n == null || Number.isNaN(Number(n))) return '—';
  const v = Number(n);
  if (v >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (v >= 1e5) return `₹${(v / 1e5).toFixed(2)} L`;
  return `₹${v.toLocaleString('en-IN')}`;
};

/** Format date input (YYYY-MM-DD) → 12 Feb 2026. */
export const fmtDate = (s) => {
  if (!s) return '—';
  try {
    return new Date(s).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return s;
  }
};

/** Deep-link helpers (Phase-1 free comms) */
export const links = {
  tel: (mobile) => (mobile ? `tel:${String(mobile).replace(/\D/g, '')}` : '#'),
  sms: (mobile, text) => (mobile ? `sms:${String(mobile).replace(/\D/g, '')}?body=${encodeURIComponent(text || '')}` : '#'),
  whatsapp: (mobile, text) => {
    if (!mobile) return '#';
    const digits = String(mobile).replace(/\D/g, '');
    const num = digits.length === 10 ? `91${digits}` : digits;
    return `https://wa.me/${num}?text=${encodeURIComponent(text || '')}`;
  },
  mail: (email, subject, body) => (email ? `mailto:${email}?subject=${encodeURIComponent(subject || '')}&body=${encodeURIComponent(body || '')}` : '#'),
};
